import { cn } from "@/lib/utils";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

type BackgroundVariant = "default" | "muted" | "gradient";

interface FeatureSectionProps {
  id: string;
  className?: string;
  children: React.ReactNode;
  background?: BackgroundVariant;
  fullHeight?: boolean;
}

const bgClasses: Record<BackgroundVariant, string> = {
  default: "bg-background",
  muted: "bg-muted/30",
  gradient: "gradient-ai-subtle",
};

export const FeatureSection = ({
  id,
  className,
  children,
  background = "default",
  fullHeight = true,
}: FeatureSectionProps) => {
  const { ref, isVisible } = useScrollAnimation({ threshold: 0.15 });

  return (
    <section
      id={id}
      ref={ref}
      className={cn(
        "relative flex items-center py-24 lg:py-32 overflow-hidden",
        fullHeight && "min-h-screen",
        bgClasses[background],
        className
      )}
    >
      {/* Background pattern */}
      <div className="absolute inset-0 bg-grid-pattern opacity-[0.02]" />

      {/* Content with animation */}
      <div
        className={cn(
          "container mx-auto px-4 animate-on-scroll",
          isVisible && "is-visible"
        )}
      >
        {children}
      </div>
    </section>
  );
};
